type Extension = 'txt' | 'csv' | 'pdf' | 'json' | 'xml'

const blobType = {
    csv: 'text/csv;charset=UTF-8',
    txt: 'application/txt',
    pdf: 'application/pdf',
    json: 'application/json',
    xml: 'application/xml',
}

export const downloadFile = (fileName: string, extension: Extension, data: string) => {
    const file = new Blob([data], { type: blobType[extension] })
    const anchor = Object.assign(document.createElement('a'), {
        href: URL.createObjectURL(file),
        target: '_blank',
        download: `${fileName}`,
        style: 'display: none',
    })
    document.body.appendChild(anchor)
    anchor.click()
    anchor.remove()
}
